//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        active: {
            type: String,
            default: ''
        }
    },

    data () {
        return {
            showLogoutCockpitScreen: false,
            items: [
                {
                    name: 'surprises',
                    label: this.$lang.get('partials.header.surprise'),
                    x: 260,
                    pointerdown: () => {
                        this.$router.push({ name: 'surprises' });
                    }
                },
                {
                    name: 'cockpit',
                    label: this.$lang.get('partials.header.cockpit'),
                    x: 550,
                    pointerdown: () => {
                        this.$router.push({ name: 'cockpit' });
                    }
                },
                {
                    name: 'help',
                    label: this.$lang.get('partials.header.help'),
                    x: 740,
                    pointerdown: () => {
                        this.$router.push({ name: 'help' });
                    }
                },
                {
                    name: 'logout',
                    label: this.$lang.get('partials.header.signout'),
                    x: 890,
                    pointerdown: () => {
                        this.showLogoutCockpitScreen = true;
                    }
                }
            ]
        };
    },

    computed: {
        stars () {
            return this.$store.getters.stars;
        },
        hasUserUnopenedSurprise () {
            return this.$store.getters.hasUserUnopenedSurprise;
        }
    }
};
